export default {
  model: [
    {
      label: 'Seu nome',
      field: 'own_name',
      type: 'text',
    },
    {
      label: 'Nome do destinatário',
      field: 'send_name',
      type: 'text',
    },
    {
      label: 'Email do destinatário',
      field: 'send_email',
      type: 'email'
    }
  ]
}